const steps = [
  {
    target: ".user-profile-picker",
    content: "This is where you can select and customize your user profile.",
    placement: "left",
    disableBeacon: true,
  },
  {
    target: ".power-device-picker",
    content: "Choose your power device here to sync your cycling data.",
    placement: "left",
  },
  {
    target: ".race-picker",
    content:
      "Select a race from the list or create a new one to start competing.",
    placement: "left",
  },
  {
    target: ".race-scheduler",
    content: "Schedule upcoming races and manage your race calendar here.",
    placement: "left",
  },
  {
    target: ".pacing-challenge",
    content:
      "Engage in pacing challenges to test and improve your cycling performance.",
    placement: "left",
  },
];

export default steps;
